var map = {
	"./Favicon.png": 96859,
	"./catalogo.png": 57555,
	"./catalogoNegative.png": 41174,
	"./catalogo_logo.png": 16621,
	"./circle_black.svg": 53547,
	"./circle_blue.svg": 74122,
	"./clientLogo.png": 14955,
	"./ellipse_black.svg": 83275,
	"./evviva-logo-dark.png": 60163,
	"./france.svg": 14098,
	"./highlighted_yellow.svg": 58049,
	"./icone": 37660,
	"./icone/": 37660,
	"./icone/AddCarrello.icona": 62969,
	"./icone/AddCarrello.icona.js": 62969,
	"./icone/AddLista.icona": 62454,
	"./icone/AddLista.icona.js": 62454,
	"./icone/Allegato.icona": 58143,
	"./icone/Allegato.icona.js": 58143,
	"./icone/ArrowLx.icona": 61375,
	"./icone/ArrowLx.icona.js": 61375,
	"./icone/ArrowRx.icona": 23933,
	"./icone/ArrowRx.icona.js": 23933,
	"./icone/ArrowsLx.icona": 46242,
	"./icone/ArrowsLx.icona.js": 46242,
	"./icone/ArrowsRx.icona": 92008,
	"./icone/ArrowsRx.icona.js": 92008,
	"./icone/Carosello.icona": 33934,
	"./icone/Carosello.icona.js": 33934,
	"./icone/Carrello.icona": 28660,
	"./icone/Carrello.icona.js": 28660,
	"./icone/Categorie.icona": 76893,
	"./icone/Categorie.icona.js": 76893,
	"./icone/Close.icona": 2962,
	"./icone/Close.icona.js": 2962,
	"./icone/Close_.icona": 91429,
	"./icone/Close_.icona.js": 91429,
	"./icone/Condividi.icona": 57019,
	"./icone/Condividi.icona.js": 57019,
	"./icone/CondividiNew.icona": 35321,
	"./icone/CondividiNew.icona.js": 35321,
	"./icone/CsvInpublish.icona": 46422,
	"./icone/CsvInpublish.icona.js": 46422,
	"./icone/Curiosita.icona": 49131,
	"./icone/Curiosita.icona.js": 49131,
	"./icone/Curiosita2.icona": 24357,
	"./icone/Curiosita2.icona.js": 24357,
	"./icone/EliminaCarrello.icona": 20293,
	"./icone/EliminaCarrello.icona.js": 20293,
	"./icone/EliminaLista.icona": 20778,
	"./icone/EliminaLista.icona.js": 20778,
	"./icone/Email.icona": 2134,
	"./icone/Email.icona.js": 2134,
	"./icone/InPublish.icona": 94632,
	"./icone/InPublish.icona.js": 94632,
	"./icone/Indice.icona": 94544,
	"./icone/Indice.icona.js": 94544,
	"./icone/Informazioni.icona": 2407,
	"./icone/Informazioni.icona.js": 2407,
	"./icone/LeftArrow.icona": 436,
	"./icone/LeftArrow.icona.js": 436,
	"./icone/LinkEsterno.icona": 91038,
	"./icone/LinkEsterno.icona.js": 91038,
	"./icone/LinkInterno.icona": 66863,
	"./icone/LinkInterno.icona.js": 66863,
	"./icone/ListaSpesa.icona": 38619,
	"./icone/ListaSpesa.icona.js": 38619,
	"./icone/Login.icona": 40287,
	"./icone/Login.icona.js": 40287,
	"./icone/Logout.icona": 78234,
	"./icone/Logout.icona.js": 78234,
	"./icone/Mappa.icona": 96083,
	"./icone/Mappa.icona.js": 96083,
	"./icone/Negozio.icona": 39821,
	"./icone/Negozio.icona.js": 39821,
	"./icone/Pagine.icona": 94218,
	"./icone/Pagine.icona.js": 94218,
	"./icone/Pdf.icona": 95248,
	"./icone/Pdf.icona.js": 95248,
	"./icone/PdfInpublish.icona": 80568,
	"./icone/PdfInpublish.icona.js": 80568,
	"./icone/Plus.icona": 66096,
	"./icone/Plus.icona.js": 66096,
	"./icone/PlusIperbimbo.icona": 46863,
	"./icone/PlusIperbimbo.icona.js": 46863,
	"./icone/Prodotti.icona": 8393,
	"./icone/Prodotti.icona.js": 8393,
	"./icone/Prodotto.icona": 29463,
	"./icone/Prodotto.icona.js": 29463,
	"./icone/ProdottoMano.icona": 80954,
	"./icone/ProdottoMano.icona.js": 80954,
	"./icone/Ricetta.icona": 51290,
	"./icone/Ricetta.icona.js": 51290,
	"./icone/Ricetta2.icona": 9290,
	"./icone/Ricetta2.icona.js": 9290,
	"./icone/SchedaTecnica.icona": 30053,
	"./icone/SchedaTecnica.icona.js": 30053,
	"./icone/SchermoIntero.icona": 54860,
	"./icone/SchermoIntero.icona.js": 54860,
	"./icone/Search.icona": 60468,
	"./icone/Search.icona.js": 60468,
	"./icone/Share.icona": 99849,
	"./icone/Share.icona.js": 99849,
	"./icone/Telefono.icona": 80468,
	"./icone/Telefono.icona.js": 80468,
	"./icone/VaiAProdotti.icona": 71190,
	"./icone/VaiAProdotti.icona.js": 71190,
	"./icone/Video.icona": 7709,
	"./icone/Video.icona.js": 7709,
	"./icone/Video2.icona": 96967,
	"./icone/Video2.icona.js": 96967,
	"./icone/VideoIperbibmo.icona": 24154,
	"./icone/VideoIperbibmo.icona.js": 24154,
	"./icone/Volantino.icona": 45520,
	"./icone/Volantino.icona.js": 45520,
	"./icone/Web.icona": 28988,
	"./icone/Web.icona.js": 28988,
	"./icone/ZoomIn.icona": 60440,
	"./icone/ZoomIn.icona.js": 60440,
	"./icone/ZoomOut.icona": 88451,
	"./icone/ZoomOut.icona.js": 88451,
	"./icone/carousel_new.svg": 77297,
	"./icone/index": 37660,
	"./icone/index.js": 37660,
	"./icons/Cart.svg": 84908,
	"./icons/Cart_add.svg": 18480,
	"./icons/Cart_delete.svg": 77226,
	"./icons/Cart_remove.svg": 69715,
	"./icons/Informazioni.icon": 81200,
	"./icons/Informazioni.icon.js": 81200,
	"./icons/_info.svg": 66853,
	"./icons/add_icon.svg": 75937,
	"./icons/add_prod.png": 50141,
	"./icons/add_prod.svg": 4038,
	"./icons/add_prodOLD.svg": 16188,
	"./icons/ask.svg": 74769,
	"./icons/carousel.svg": 96928,
	"./icons/carrello.svg": 17790,
	"./icons/categorie.svg": 17475,
	"./icons/clear_chart.svg": 24568,
	"./icons/clear_chartOLD.png": 16371,
	"./icons/clear_chart_.png": 12467,
	"./icons/close.png": 88992,
	"./icons/close.svg": 75126,
	"./icons/close_.svg": 15981,
	"./icons/condividi.svg": 66185,
	"./icons/download_img.png": 51862,
	"./icons/email.svg": 30582,
	"./icons/facebook.svg": 52542,
	"./icons/fb.png": 79758,
	"./icons/hatchef.svg": 67557,
	"./icons/icon-carousel.svg": 84804,
	"./icons/icone/_info.svg": 93724,
	"./icons/icone/book-open-solid.svg": 68209,
	"./icons/icone/columns-solid.svg": 86148,
	"./icons/icone/file-pdf-solid.svg": 96068,
	"./icons/icone/hatchef.svg": 82468,
	"./icons/icone/info.svg": 30697,
	"./icons/icone/list-solid.svg": 12635,
	"./icons/icone/magnifying-glass-solid.svg": 6555,
	"./icons/icone/play.svg": 51303,
	"./icons/icone/plus.svg": 8961,
	"./icons/icone/share-square-solid-prod.svg": 87462,
	"./icons/icone/share-square-solid.svg": 42428,
	"./icons/icone/specs.svg": 67227,
	"./icons/icone/world.svg": 14583,
	"./icons/index-icon-bookmark.svg": 93553,
	"./icons/index-icon.svg": 50376,
	"./icons/info.svg": 94858,
	"./icons/informazioni.svg": 20051,
	"./icons/internal_link.svg": 94212,
	"./icons/mappa.svg": 77097,
	"./icons/markers-SVG/ask.svg": 55732,
	"./icons/markers-SVG/info.svg": 75645,
	"./icons/markers-SVG/list.svg": 44401,
	"./icons/markers-SVG/recipe.svg": 80143,
	"./icons/markers-SVG/web.svg": 30001,
	"./icons/new_list.png": 33015,
	"./icons/new_list_mobile.png": 62730,
	"./icons/new_list_white.png": 91997,
	"./icons/pagine.svg": 39048,
	"./icons/pdf.svg": 99508,
	"./icons/play.svg": 7840,
	"./icons/play_ip.svg": 7252,
	"./icons/plus.svg": 68718,
	"./icons/plus_ip.svg": 26618,
	"./icons/prodotti.svg": 19533,
	"./icons/promo.svg": 76927,
	"./icons/promo2.svg": 54287,
	"./icons/promo3.svg": 17886,
	"./icons/promo_10.svg": 26869,
	"./icons/promo_classic.svg": 40686,
	"./icons/remove_prod.svg": 70562,
	"./icons/remove_prodOLD.svg": 60337,
	"./icons/remove_prod_.svg": 96921,
	"./icons/ricetta.svg": 27914,
	"./icons/schermo_intero.svg": 42805,
	"./icons/shop_list.svg": 87917,
	"./icons/shpo-list.png": 50419,
	"./icons/specs.svg": 24682,
	"./icons/telephone.svg": 61650,
	"./icons/video.svg": 9447,
	"./icons/volantino.svg": 18372,
	"./icons/wa.png": 41166,
	"./icons/whatsapp.svg": 12700,
	"./icons/white_add_prod.png": 32319,
	"./icons/white_add_prodOLD.png": 42912,
	"./icons/world.svg": 42942,
	"./interattico_icon.png": 14617,
	"./italian.png": 3891,
	"./logo.png": 82806,
	"./logo_catalog_interattivo.svg": 97326,
	"./logo_client.png": 44406,
	"./logo_interattivo-old.svg": 61194,
	"./logo_interattivo.png": 23702,
	"./logo_interattivo.svg": 43534,
	"./logo_interattivo_free.png": 99809,
	"./logo_interattivo_free.svg": 19855,
	"./logo_interattivo_negative.png": 28454,
	"./logo_interattivo_new.svg": 52069,
	"./logo_menu_interattivo.svg": 2500,
	"./logo_new.png": 8281,
	"./logo_volantinointerattivo_free.svg": 84671,
	"./menu.png": 96582,
	"./menuNegative.png": 16187,
	"./menu_logo.png": 78398,
	"./no_vol.png": 24584,
	"./no_vol_m.png": 61068,
	"./non-disponibile.png": 42919,
	"./prodotto.png": 89594,
	"./searchpagelogo.png": 12795,
	"./spanishflag.png": 62285,
	"./usaflag.png": 50576,
	"./user-img.png": 70896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;